import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { annulmentCarrierFailed, annulmentCarrierSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { deniedApplicationFailed } from '../../Application/actions';

export default function* annulmentCarrier(action) {
  try {
    const { id, values } = action.payload;
    if (!id) { throw new Error('ID not found'); }
    const url = `${BACKEND_URL}/registries/carriers/${id}/revoke`;
    const response = yield makeRequest(url, values, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(annulmentCarrierSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(annulmentCarrierFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(annulmentCarrierFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
